export interface MeasurementField {
  name: string;
  label: string;
  placeholder: string;
  required?: boolean;
}

export const CATEGORY_MEASUREMENTS: { [categoryName: string]: MeasurementField[] } = {
  'Pants': [
    { name: 'waist', label: 'Waist', placeholder: 'e.g., 32cm', required: true },
    { name: 'hips', label: 'Hips', placeholder: 'e.g., 94cm', required: true },
    { name: 'rise', label: 'Rise', placeholder: 'e.g., 28cm', required: true },
    { name: 'inseam', label: 'Inside leg (inseam)', placeholder: 'e.g., 72cm', required: true },
    { name: 'length', label: 'Length', placeholder: 'e.g., 98cm', required: true },
    { name: 'leg_opening', label: 'Leg opening', placeholder: 'e.g., 18cm' }
  ],
  
  'Skirts': [
    { name: 'waist', label: 'Waist', placeholder: 'e.g., 30cm', required: true },
    { name: 'hips', label: 'Hips', placeholder: 'e.g., 94cm', required: true },
    { name: 'length', label: 'Length', placeholder: 'e.g., 45cm', required: true },
    { name: 'hem_width', label: 'Hem width', placeholder: 'e.g., 120cm' }
  ],
  
  'Dresses': [
    { name: 'bust', label: 'Bust', placeholder: 'e.g., 88cm', required: true },
    { name: 'waist', label: 'Waist', placeholder: 'e.g., 68cm', required: true },
    { name: 'hips', label: 'Hips', placeholder: 'e.g., 94cm', required: true },
    { name: 'shoulders', label: 'Shoulders', placeholder: 'e.g., 38cm', required: true },
    { name: 'sleeve_length', label: 'Sleeve length', placeholder: 'e.g., 60cm' },
    { name: 'dress_length', label: 'Dress length', placeholder: 'e.g., 95cm', required: true }
  ],
  
  'Tops & Shirts': [
    { name: 'bust', label: 'Bust', placeholder: 'e.g., 88cm', required: true },
    { name: 'waist', label: 'Waist', placeholder: 'e.g., 68cm' },
    { name: 'shoulders', label: 'Shoulders', placeholder: 'e.g., 38cm', required: true },
    { name: 'sleeve_length', label: 'Sleeve length', placeholder: 'e.g., 60cm' },
    { name: 'top_length', label: 'Top length', placeholder: 'e.g., 55cm', required: true }
  ],
  
  'Corsets & Lingerie': [
    { name: 'bust', label: 'Bust', placeholder: 'e.g., 88cm', required: true },
    { name: 'underbust', label: 'Underbust', placeholder: 'e.g., 78cm', required: true },
    { name: 'waist', label: 'Waist', placeholder: 'e.g., 68cm', required: true },
    { name: 'hips', label: 'Hips', placeholder: 'e.g., 94cm' },
    { name: 'length', label: 'Length', placeholder: 'e.g., 35cm', required: true }
  ],
  
  'Shorts & Capris': [
    { name: 'waist', label: 'Waist', placeholder: 'e.g., 32cm', required: true },
    { name: 'hips', label: 'Hips', placeholder: 'e.g., 94cm', required: true },
    { name: 'rise', label: 'Rise', placeholder: 'e.g., 25cm', required: true },
    { name: 'inseam', label: 'Inside leg (inseam)', placeholder: 'e.g., 15cm', required: true },
    { name: 'leg_opening', label: 'Leg opening', placeholder: 'e.g., 22cm' }
  ],
  
  'Jackets & Vests': [
    { name: 'chest_bust', label: 'Chest/Bust', placeholder: 'e.g., 96cm', required: true },
    { name: 'waist', label: 'Waist', placeholder: 'e.g., 80cm' },
    { name: 'shoulders', label: 'Shoulders', placeholder: 'e.g., 42cm', required: true },
    { name: 'sleeve_length', label: 'Sleeve length', placeholder: 'e.g., 62cm' },
    { name: 'length', label: 'Length', placeholder: 'e.g., 65cm', required: true },
    { name: 'armhole', label: 'Armhole', placeholder: 'e.g., 20cm' }
  ],
  
  'Bags': [
    { name: 'width', label: 'Width', placeholder: 'e.g., 30cm', required: true },
    { name: 'height', label: 'Height', placeholder: 'e.g., 25cm', required: true },
    { name: 'depth', label: 'Depth', placeholder: 'e.g., 12cm', required: true },
    { name: 'strap_drop', label: 'Strap drop', placeholder: 'e.g., 55cm' },
    { name: 'opening', label: 'Opening', placeholder: 'e.g., 28cm' }
  ],
  
  'Hats': [
    { name: 'head_size', label: 'Head size', placeholder: 'e.g., 58cm', required: true },
    { name: 'crown_height', label: 'Crown height', placeholder: 'e.g., 12cm' },
    { name: 'brim_width', label: 'Brim width', placeholder: 'e.g., 8cm' }
  ],
  
  'Belts & Scarves': [], // Will be handled by product type
  
  'Sunglasses': [
    { name: 'lens_width', label: 'Lens width', placeholder: 'e.g., 52mm', required: true },
    { name: 'lens_height', label: 'Lens height', placeholder: 'e.g., 42mm', required: true },
    { name: 'bridge', label: 'Bridge', placeholder: 'e.g., 18mm', required: true },
    { name: 'arm_length', label: 'Arm length', placeholder: 'e.g., 140mm', required: true },
    { name: 'frame_width', label: 'Frame width', placeholder: 'e.g., 140mm', required: true }
  ],
  
  'Glasses': [
    { name: 'lens_width', label: 'Lens width', placeholder: 'e.g., 52mm', required: true },
    { name: 'lens_height', label: 'Lens height', placeholder: 'e.g., 42mm', required: true },
    { name: 'bridge', label: 'Bridge', placeholder: 'e.g., 18mm', required: true },
    { name: 'arm_length', label: 'Arm length', placeholder: 'e.g., 140mm', required: true },
    { name: 'frame_width', label: 'Frame width', placeholder: 'e.g., 140mm', required: true }
  ]
};

// Product type specific measurements for Belts & Scarves
export const PRODUCT_TYPE_MEASUREMENTS: { [productType: string]: MeasurementField[] } = {
  'Belt': [
    { name: 'length', label: 'Length', placeholder: 'e.g., 95cm', required: true },
    { name: 'width', label: 'Width', placeholder: 'e.g., 3cm', required: true },
    { name: 'fit_range', label: 'Fit range', placeholder: 'e.g., 70-90cm' }
  ],
  
  'Scarf': [
    { name: 'length', label: 'Length', placeholder: 'e.g., 180cm', required: true },
    { name: 'width', label: 'Width', placeholder: 'e.g., 60cm', required: true }
  ]
};

export const getCategoryMeasurements = (categoryName: string, productType?: string): MeasurementField[] => {
  // Special handling for Belts & Scarves with product type
  if (categoryName === 'Belts & Scarves' && productType) {
    return PRODUCT_TYPE_MEASUREMENTS[productType] || [];
  }
  
  return CATEGORY_MEASUREMENTS[categoryName] || [];
};

export const getProductTypes = (categoryName: string): string[] => {
  if (categoryName === 'Belts & Scarves') {
    return ['Belt', 'Scarf'];
  }
  return [];
};

// A product can sit in several categories: offer the product types of all of
// them and merge their measurement fields (first occurrence of a name wins).
export const getProductTypesForCategories = (categoryNames: string[]): string[] =>
  Array.from(new Set(categoryNames.flatMap(getProductTypes)));

export const getMeasurementsForCategories = (categoryNames: string[], productType?: string): MeasurementField[] => {
  const seen = new Set<string>();
  return categoryNames
    .flatMap(name => getCategoryMeasurements(name, productType))
    .filter(field => !seen.has(field.name) && seen.add(field.name));
};
